<template>
   <router-view />
</template>

<script setup>
</script>

<style>
body,
html {
   width: 100vw;
   height: 100vh;
   overflow: hidden;
}
</style>